/* unplugin-vue-components disabled */import { render } from "./VideoPlayer.vue?vue&type=template&id=3e3385ae&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import "./VideoPlayer.vue?vue&type=style&index=0&id=3e3385ae&scoped=true&lang=css"

import exportComponent from "D:\\daima\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3385ae"]])

export default __exports__